module.exports = __webpack_public_path__ + "static/beholder_keen-b6555fe6abd52246a6fec704083c046a.png";